var map = {
	"./404.md": 630,
	"./README.md": 631,
	"./RFC.html": 632,
	"./_template.jsx": 364,
	"./enterprise2.0.md": 633,
	"./gutenberg/index.md": 634,
	"./html-elements.html": 635,
	"./index.md": 636,
	"./newspaper.md": 637,
	"./old-styleguide.cjsx": 638,
	"./styleguide.html": 639,
	"./what.md": 640
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;



/*****************
 ** WEBPACK FOOTER
 ** . (coffee|cjsx|jsx|js|markdown|md|html|json|yaml|toml)$
 ** module id = 629
 ** module chunks = 0
 **/